/* This is generated code, don't alter */
var IfcCostScheduleTypeEnum;
(function (IfcCostScheduleTypeEnum) {
    IfcCostScheduleTypeEnum[IfcCostScheduleTypeEnum["BUDGET"] = 0] = "BUDGET";
    IfcCostScheduleTypeEnum[IfcCostScheduleTypeEnum["COSTPLAN"] = 1] = "COSTPLAN";
    IfcCostScheduleTypeEnum[IfcCostScheduleTypeEnum["ESTIMATE"] = 2] = "ESTIMATE";
    IfcCostScheduleTypeEnum[IfcCostScheduleTypeEnum["TENDER"] = 3] = "TENDER";
    IfcCostScheduleTypeEnum[IfcCostScheduleTypeEnum["PRICEDBILLOFQUANTITIES"] = 4] = "PRICEDBILLOFQUANTITIES";
    IfcCostScheduleTypeEnum[IfcCostScheduleTypeEnum["UNPRICEDBILLOFQUANTITIES"] = 5] = "UNPRICEDBILLOFQUANTITIES";
    IfcCostScheduleTypeEnum[IfcCostScheduleTypeEnum["SCHEDULEOFRATES"] = 6] = "SCHEDULEOFRATES";
    IfcCostScheduleTypeEnum[IfcCostScheduleTypeEnum["USERDEFINED"] = 7] = "USERDEFINED";
    IfcCostScheduleTypeEnum[IfcCostScheduleTypeEnum["NOTDEFINED"] = 8] = "NOTDEFINED";
})(IfcCostScheduleTypeEnum || (IfcCostScheduleTypeEnum = {}));
const IfcCostScheduleTypeEnumCount = 9;
export { IfcCostScheduleTypeEnum, IfcCostScheduleTypeEnumCount };
/* This is generated code, don't alter */
import MinimalPerfectHash from "../../indexing/minimal_perfect_hash.js";
let gMapIfcCostScheduleTypeEnum = new Int32Array([-8, -2, 43]);
let prefixSumAddressIfcCostScheduleTypeEnum = new Uint32Array([0, 8, 25, 49, 57, 83, 95, 105, 115, 128]);
let slotMapIfcCostScheduleTypeEnum = new Int32Array([3, 6, 4, 0, 5, 8, 1, 2, 7]);
let encodedDataIfcCostScheduleTypeEnum = (new TextEncoder()).encode(".TENDER..SCHEDULEOFRATES..PRICEDBILLOFQUANTITIES..BUDGET..UNPRICEDBILLOFQUANTITIES..NOTDEFINED..COSTPLAN..ESTIMATE..USERDEFINED.");
let IfcCostScheduleTypeEnumSearch = new MinimalPerfectHash(gMapIfcCostScheduleTypeEnum, prefixSumAddressIfcCostScheduleTypeEnum, slotMapIfcCostScheduleTypeEnum, encodedDataIfcCostScheduleTypeEnum);
export { IfcCostScheduleTypeEnumSearch };
/* This is generated cold, don't alter */
import StepEnumParser from "../../step/parsing/step_enum_parser.js";
const parser = StepEnumParser.Instance;
export function IfcCostScheduleTypeEnumDeserializeStep(input, cursor, endCursor) {
    return parser.extract(IfcCostScheduleTypeEnumSearch, input, cursor, endCursor);
}
